import { Component } from "@angular/core";
import { MenuController, Platform } from "@ionic/angular";
import { MenuOptionModel } from "src/app/interfaces/sidemenu-interface";
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { ConfigService } from "src/app/services/config/config.service";
import { SidemenuService } from "src/app/services/sidemenu/sidemenu.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";

@Component({
  selector: "sidemenu",
  templateUrl: "sidemenu.html",
  styleUrls: ["./sidemenu.scss"],
})
export class SidemenuComponent {

  public externalLinks: any;
  public menuOptions: Array<MenuOptionModel>;
  public removeItem: any[] = [];
  public isIOSApp: boolean = false;

  constructor(
    private config: ConfigService,
    private sidemenuService: SidemenuService,
    private menuCtrl: MenuController,
    private platform: Platform,
    private appLinks: AppLinksService,
    private userSession:UserSessionService
  ) {
    this.externalLinks = this.sidemenuService.getExternalLinks();
  }

  ngOnInit(): void {
    this.processSidemenuFilter();
    this.isIOSApp = this.platform.is('ios') && this.platform.is('capacitor');
    this.userSession.getCustomer().subscribe(customer => {
      if (!!customer) {
        this.sidemenuService.getSidemenuData().then(
          data => this.menuOptions = data
        );
      }
    })
  }

  protected openExternalLinks(links): any {
    return this.sidemenuService.openExternalLinks(links);
  }

  private processSidemenuFilter(): void {
    const menuFilterArrayString = this.config.getConfig().MENU_FILTER_ARRAY;
    // Use MENU_FILTER_ARRAY to define filtering menu item using config.
    if (menuFilterArrayString && menuFilterArrayString.trim() !== '') {
      try {
        this.removeItem = JSON.parse(menuFilterArrayString);
      } catch (error) {
        console.error('Error parsing MENU_FILTER_ARRAY:', error);
        this.removeItem = [];
      }
    } else {
      this.removeItem = [];
    }

    this.getSideMenuData();
  }

  private getSideMenuData(): void {
    this.sidemenuService.getSidemenuData().then(
      data => {
        const filterMenuOptions = (options: MenuOptionModel[]) => {
          return options.filter(option => {
            if (this.removeItem.includes(option.component)) {
              return false;
            }
            if (option.subItems && option.subItems.length > 0) {
              option.subItems = filterMenuOptions(option.subItems);
              return option.subItems.length > 0;
            }
            return true;
          });
        };

        this.menuOptions = filterMenuOptions(data);


        if (Array.isArray(this.menuOptions)) {
          this.setSubItemsHidden(this.menuOptions, true);
          this.hideAllSubUnits(this.menuOptions);
        }
      }
    );
  }
  setSubItemsHidden = (items, topLevel = false) => {
    items.forEach(item => {
      if (!topLevel) {
        item.isHidden = true;
      }
      if (item.subItems && Array.isArray(item.subItems)) {
        this.setSubItemsHidden(item.subItems);
      }

    });
  };

  protected onLogout(): any {
    return this.sidemenuService.sidemenuLogout();
  }

  public toggleItemOptions(option: any, level: number): any {
    if (!option) return console.error("Option is not defined");
    if (level === 2) return this.levelTwoToggle(option);
    if (level === 3) return this.levelThreeToggle(option);
  }

  private levelTwoToggle(option: any): void {
    this.menuOptions.forEach(item => {
      (item === option) ? item.subItemsHidden = !item.subItemsHidden : item.subItemsHidden = false;

      if (item === option && item.subItems && Array.isArray(item.subItems)) {
        item.subItems.forEach(subItem => {
          if (item === option) subItem.subItemsHidden = false;
          subItem.isHidden = !subItem.isHidden;
          if (subItem.subItems && Array.isArray(subItem.subItems)) {
            subItem.subItems.forEach(SubUnit => {
              SubUnit.isHidden = true;
            })
          }
        });
      }
      if (item !== option && item.subItems && Array.isArray(item.subItems)) {
        this.hideAllSubUnits(item.subItems);
      }
    });
  }

  private levelThreeToggle(option: any): void {
    const parentOption = this.findParentOption(option);

    this.menuOptions.forEach(item => {
      if (item === parentOption && item.subItems && Array.isArray(item.subItems)) {
        item.subItems.forEach(subItem => {
          (subItem === option) ? subItem.subItemsHidden = !subItem.subItemsHidden : subItem.subItemsHidden = false;
          if (subItem === option && subItem.subItems && Array.isArray(subItem.subItems)) {
            subItem.subItems.forEach(SubUnit => {
              SubUnit.isHidden = !SubUnit.isHidden;
            })
          }
          if (subItem !== option && subItem.subItems && Array.isArray(subItem.subItems)) {
            this.hideAllSubUnits(subItem.subItems);
          }
        });
      }
    });
  }

  private findParentOption(option: any): any {
    return this.menuOptions.find(parent => {
      return parent.subItems && parent.subItems.includes(option);
    });
  }

  private hideAllSubUnits(subItems: any[]): void {
    subItems.forEach(SubUnit => {
      SubUnit.isHidden = true;
      SubUnit.subItemsHidden = false;
      if (SubUnit.subItems && Array.isArray(SubUnit.subItems)) {
        this.hideAllSubUnits(SubUnit.subItems);
      }
    });
  }

  public select(option: MenuOptionModel): void {
    if (option?.clickAction === 'onDeposit') return this.sidemenuService.onDeposit();
    if(option?.isExternalLink) return this.appLinks.openExternalPage(option?.link)
    this.sidemenuService.navigateToAPage(option.component);
  }


  public closeSidemenu(menuSide: string) {
    return this.menuCtrl.close(menuSide);
  }
}
